import { jsxs, jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-pill.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
import { liveAnnounce, Level } from '../../utils/live-announce/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSRemovablePill = props => {
  const {
    active,
    a11yRemoveText,
    altText,
    analytics,
    children,
    className,
    disabled,
    icon,
    id,
    name,
    onClick,
    buttonRef,
    value
  } = props;
  const baseClassName = 'uitk-pill';
  const l10n = useLocalization();
  const handleClick = evt => {
    if (a11yRemoveText) {
      liveAnnounce(a11yRemoveText, Level.POLITE);
    }
    onClick(evt);
  };
  const wrapperClassName = getClassNameList(`${baseClassName} ${baseClassName}-removable ${baseClassName}-content`, className, {
    [`${baseClassName}-disabled`]: disabled,
    [`${baseClassName}-active`]: active
  });
  let ariaLabel = '';
  if (altText) {
    ariaLabel = altText;
  } else {
    ariaLabel = `${l10n.formatText('remove')} ${children}`;
  }
  return jsxs("button", {
    id: id,
    name: name,
    onClick: handleClick,
    onClickCapture: analytics && analyticsTracker.bind(undefined, analytics),
    className: wrapperClassName,
    type: "button",
    disabled: disabled,
    "aria-label": ariaLabel,
    ref: buttonRef,
    value: value,
    children: [icon && jsx(EGDSIcon, {
      className: getClassNameList(`${baseClassName}-icon`),
      name: icon
    }), jsx("span", {
      className: getClassNameList(`${baseClassName}-text`),
      children: children
    }), jsx(EGDSIcon, {
      className: getClassNameList(`${baseClassName}-action-icon`),
      name: "close"
    })]
  });
};
EGDSRemovablePill.displayName = 'EGDSRemovablePill';
export { EGDSRemovablePill };